import {
    COLLECTION_FAILURE,
    COLLECTION_REQUEST,
    COLLECTION_SUCCESS
} from '../actions/types/dashboard-action-types';

import { combineReducers } from 'redux';

function byId( state = {}, action ){
    let newState;
    switch( action.type ){
        case COLLECTION_REQUEST:
            newState = {};
            break;
        case COLLECTION_SUCCESS:
            newState = action.payload.entities.collections;
            break;
        default:
            newState = state;
    }

    return newState;
}

function allIds( state = [], action ){
    let newState;
    switch( action.type ){
        case COLLECTION_REQUEST:
            newState = [];
            break;
        case COLLECTION_SUCCESS:
            newState = action.payload.result.collections;
            break;
        default:
            newState = state;
    }

    return newState;
}

function isLoading( state = false, action ){
    let newState;
    switch( action.type ){
        case COLLECTION_REQUEST:
            newState = true;
            break;
        case COLLECTION_SUCCESS:
        case COLLECTION_FAILURE:
            newState = false;
            break;
        default:
            newState = state;
    }

    return newState;
}

export default combineReducers( {
    allIds,
    byId,
    isLoading,
} );
